export enum PlaylistType {
  SAME_CATEGORY_SIMILAR_OFFERS = 'sameCategorySimilarOffers',
  OTHER_CATEGORIES_SIMILAR_OFFERS = 'otherCategoriesSimilarOffers',
  SAME_ARTIST_PLAYLIST = 'sameArtistPlaylist',
  SEARCH_RESULTS = 'searchResults',
  TOP_OFFERS = 'topOffers',
}
